module.exports = __webpack_public_path__ + "img/xmasParty8.89dfbbd1.jpg";